import React from 'react'
import './footer.css'

import {FaXingSquare} from 'react-icons/fa'
import {FaGithub} from 'react-icons/fa'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Nick Wahrenberger</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.xing.com/profile/Nick_Wahrenberger/cv" target="_blank"><FaXingSquare/></a>
        <a href="https://github.com/SoftTechNick" target="_blank"><FaGithub/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Nick Wahrenberger. All rights reserved.</small>
      </div>
    </footer>
  )
}

export default Footer